import { Tag, TagVariant } from '@creditornot/cb-tag';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { PhotoShootStatus } from 'apis/mips/types';

type PhotoShootStatusTagProps = {
  status: PhotoShootStatus;
};

const StatusToConfigMap: Record<PhotoShootStatus, { translationId: string; variant: TagVariant }> = {
  [PhotoShootStatus.CREATED]: {
    translationId: 'photo-shoot.status.opened',
    variant: 'lightBlue',
  },
  [PhotoShootStatus.UPLOADED]: {
    translationId: 'photo-shoot.status.submitted',
    variant: 'lightOrange',
  },
  [PhotoShootStatus.APPROVED]: {
    translationId: 'photo-shoot.status.approved',
    variant: 'lightGreen',
  },
};

export const PhotoShootStatusTag = ({ status }: PhotoShootStatusTagProps) => {
  const statusConfig = StatusToConfigMap[status];

  return (
    <Tag variant={statusConfig.variant}>
      <FormattedMessage id={statusConfig.translationId} />
    </Tag>
  );
};
